module.exports = __webpack_public_path__ + "static/img/counter_02.876dcdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/counter_02.png
// module id = bUHB
// module chunks = 0